<template>
  <div class="ft-card">
    <div class="ft-card-header-row">
      <h3 class="ft-card-title">
        <i class="fas" :class="isEdit ? 'fa-pencil-alt' : 'fa-plus-square'"></i>
        {{ isEdit ? 'Edit Blog Post' : 'New Blog Post' }}
      </h3>
    </div>

    <form @submit.prevent="save">
      <div class="ft-field-row">
        <label class="ft-field-label">Title</label>
        <input type="text" v-model="form.title" required>
        <div class="ft-error-text" v-if="errors.title">{{ errors.title[0] }}</div>
      </div>

      <div class="ft-field-row">
        <label class="ft-field-label">Banner Image {{ isEdit ? '(leave empty to keep current)' : '' }}</label>
        <img v-if="isEdit && currentBanner" :src="storageUrl + 'banner_content/' + currentBanner" alt="" class="ft-preview">
        <input type="file" accept="image/*" @change="onFileChange" :required="!isEdit">
        <div class="ft-error-text" v-if="errors.banner">{{ errors.banner[0] }}</div>
      </div>

      <div class="ft-field-row">
        <label class="ft-field-label">Content</label>
        <vue-editor
          v-model="form.description"
          :editor-toolbar="toolbar"
          placeholder="Write the article content here..."
        />
        <div class="ft-error-text" v-if="errors.description">{{ errors.description[0] }}</div>
      </div>

      <div class="ft-field-row" style="max-width:220px;">
        <label class="ft-field-label">Status</label>
        <select v-model="form.status">
          <option value="published">Published</option>
          <option value="draft">Draft</option>
        </select>
      </div>

      <div class="ft-action-cell">
        <button type="submit" class="ft-btn" :disabled="saving">
          <i class="fas fa-spinner fa-spin" v-if="saving"></i>
          <i class="fas fa-check" v-else></i>
          {{ saving ? 'Saving...' : (isEdit ? 'Update Post' : 'Create Post') }}
        </button>
        <router-link to="/admin/blog" class="ft-btn ft-btn-outline"><i class="fas fa-times"></i> Cancel</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import blog from '@/services/adminBlog.service';
import config from '@/configs/config';

export default {
  name: 'AdminBlogForm',
  components: { VueEditor },
  data() {
    return {
      form: { title: '', description: '', status: 'published' },
      bannerFile: null,
      currentBanner: '',
      errors: {},
      saving: false,
      storageUrl: config.blogStorageUrl,
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
        ['blockquote', 'link', 'image', 'video'],
        ['clean'],
      ],
    };
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id;
    },
  },
  mounted() {
    if (this.isEdit) {
      blog.show(this.$route.params.id).then((response) => {
        const post = response.data.data;
        this.form.title = post.title;
        this.form.description = post.description;
        this.form.status = post.status;
        this.currentBanner = post.banner;
      });
    }
  },
  methods: {
    onFileChange(e) {
      this.bannerFile = e.target.files[0];
    },
    save() {
      this.errors = {};
      const plainText = this.form.description.replace(/<[^>]*>/g, '').trim();
      if (!plainText) {
        this.errors = { description: ['The content field is required.'] };
        return;
      }

      this.saving = true;
      const formData = new FormData();
      formData.append('title', this.form.title);
      formData.append('description', this.form.description);
      formData.append('status', this.form.status);
      if (this.bannerFile) {
        formData.append('banner', this.bannerFile);
      }

      const request = this.isEdit
        ? blog.update(this.$route.params.id, formData)
        : blog.create(formData);

      request.then(() => {
        this.$router.push('/admin/blog');
      }).catch((err) => {
        if (err.response && err.response.status === 422) {
          this.errors = err.response.data.errors;
        }
      }).finally(() => {
        this.saving = false;
      });
    },
  },
};
</script>
